var _path, _path2, _text;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgC02 = function SvgC02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a67754b0-441d-46d1-84c8-ce085e2de12d",
    "data-name": "Layer 2",
    viewBox: "0 0 154.49 102.21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f96776c9-007f-4f12-82d1-a69c085f60a9",
    d: "M137.17,54.19a25.81,25.81,0,0,0-5.8.67,32.54,32.54,0,0,0-65,1.63c0,1.11.06,2.24.17,3.36A23.17,23.17,0,0,0,69.36,106h67.81a25.92,25.92,0,0,0,0-51.83Zm0,47.22H69.36a18.57,18.57,0,0,1-.19-37.13,2.32,2.32,0,0,0,1.75-.84,2.28,2.28,0,0,0,.49-1.88,27.93,27.93,0,1,1,55.39-5.07q0,.67,0,1.35a2.28,2.28,0,0,0,.93,2,2.32,2.32,0,0,0,2.16.31,21.3,21.3,0,1,1,7.31,41.3Z",
    transform: "translate(-8.59 -3.8)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "f96776c9-007f-4f12-82d1-a69c085f60a9",
    d: "M61.28,8.41A28,28,0,0,1,82.34,18a2.3,2.3,0,1,0,3.48-3A32.53,32.53,0,0,0,28.75,36.34c0,1.11.06,2.23.17,3.35a23.17,23.17,0,0,0,2.85,46.17,2.31,2.31,0,0,0,0-4.61,18.57,18.57,0,0,1-.19-37.13,2.28,2.28,0,0,0,1.75-.83,2.35,2.35,0,0,0,.49-1.89,27.89,27.89,0,0,1,27.46-33Z",
    transform: "translate(-8.59 -3.8)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "b4b66d71-250b-43f1-8933-98795a6a25ba",
    transform: "translate(65.87 82.62)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "af080e44-e339-426f-9f83-3e5a0b09f4bb"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.12,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "e3542e81-3682-4592-862d-fdb868aea521",
    x: 44.93,
    y: 0
  }, "\u2082"))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgC02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/c02.dc5ecb71.svg";
export { ForwardRef as ReactComponent };